import { render, staticRenderFns } from "./Pit.vue?vue&type=template&id=27468ca8"
import script from "./Pit.vue?vue&type=script&lang=js"
export * from "./Pit.vue?vue&type=script&lang=js"
import style0 from "./Pit.vue?vue&type=style&index=0&id=27468ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports